import React, {Component} from "react";
import {Button, Col, message, Popconfirm, Row, Spin, Switch, Tabs} from 'antd';
import {connect} from 'react-redux';
import {Feature, Map, View} from "ol";
import LayerGroup from "ol/layer/Group";
import ImageLayer from "ol/layer/Image";
import Static from "ol/source/ImageStatic";
import Projection from "ol/proj/Projection";
import {DoubleClickZoom} from "ol/interaction";
import {getCenter} from "ol/extent";
import {
    advancedModeAdminKeys,
    advancedModeKeyNames,
    advancedModeSettingKeys, advancedModeSettingKeysNames,
    advancedModeSlideSettingKeys, BrightnessKey, ContrastKey, EnhanceKey, ExposureKey, GammaKey
} from "../../gammaviewer/keys/Settings"
import {pointSelectionModeVals, scanSettingsTypeVals, scanWorkflowLoadingMessages} from "../../../utils/const";
import Point from "ol/geom/Point";
import {Fill, Stroke, Style} from "ol/style";
import CircleStyle from "ol/style/Circle";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {setDeviceBusy, setDeviceIdle} from "../../../redux_actions/device_status.action";
import axios from "axios";
import {AuthHeader} from "../../../configs/auth.token";
import {
    setDropDistancePointOnly,
    setFocusPoints,
    setScanProfile,
    updateActionOngoing
} from "../../../redux_actions/preview_status.action";

import '../../../asset/style/workflow/advanced-preview-settings-component.css';
import {
    fetchAllDisplaySettings,
    getIdFromName,
    getSliderRows,
    getViewerSettingDropdown,
    hasEditSlideSettingPermission
} from "../slot_component_utils";
import {checkAbstractAppPermission, specimenBasedViewerSettingApp} from "component/utils/abstract_app_maker";
import {isOwner} from "component/gammaviewer/utils/displaySettingsUtils";
import {isTrue} from "utils/utils";
import cookie from "react-cookies";
import {getSettingComponent} from "component/gammaviewer/utils/settingsUtils";
import {updateDefaultStainSettings, updateDisplaySettingsList, updateSettings} from "redux_actions/gamma.state.action";
import {patch, post} from "helper/request";
import {error_manager} from "helper/error_manager";
import {LoadingOutlined} from "@ant-design/icons";
import {get_response, post_response} from "../../../helper/request";
import {getStateAwareUrl} from "../../../utils/utils";
import {aclPermissions, hasPermissions} from "../../../const/ACLPermissions";
import FortyXImage from "./fortyXImage";

const { TabPane } = Tabs;

class AdvancedPreviewSettingsComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pointSelectionMode: pointSelectionModeVals.COARSE,
            showLatestImage: false,
            currImagePos: [],
            pointAlreadyPresent: false,
            fetchingMessage: "",
            getImageOnEveryClick: props.preview.response.beingUsedForPreviewCalibration,
            move: {x:0, y:0},
            isFirstTime: true,
            currResponse: this.props.currResponse,
            sliderValues: {},
            isFetching: true,
        }

        this.image = new Image();

        this.image.onload = this.onloadRunner;

        this.onloadRunner = this.onloadRunner.bind(this);
    }

    componentDidMount = () => {
        this.image.src = getStateAwareUrl('/dev-ssd/' + this.props.preview.response.uploadLocation + '?time=' + Date.now());
        document.addEventListener("keypress", this.onKeyPress, false);

        let id = getIdFromName(this.props.displaySettingsList, this.props.displaySettings)
        advancedModeKeyNames.forEach(setting => {
            let initValues = this.state.sliderValues
            initValues[setting] = this.props.displaySettingsList[id][setting]
            this.setState({
                sliderValues: initValues
            })
        })

        this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.LOADING));
        let partsOfUrl = "api~scan~get_camera_info/";
        let url = `/server/scano/` + this.props.deviceId + `/` + partsOfUrl + "?objectiveType=" + this.props.preview.objectiveType;
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status === 200) {
                    console.log(response);
                    this.setState({
                        livemodeConfig: response.data.livemodeConfig
                    });
                }
                else {
                    console.log(response);
                    message.error("Not able to get camera settings!!", 2.5);
                }
                this.setState({
                    isFetching: false
                })
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
            .catch(err => {
                console.log(err);
                message.error("Not able to get camera settings!!", 2.5);
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.scanSettingsType !== this.props.scanSettingsType 
            && this.props.scanSettingsType === scanSettingsTypeVals.ADVANCED) {
            this.image.src = getStateAwareUrl('/dev-ssd/' + this.props.preview.response.uploadLocation + '?time=' + Date.now());
            this.setState({
                pointSelectionMode: pointSelectionModeVals.COARSE,
                showLatestImage: false,
                currImagePos: [],
                pointAlreadyPresent: false,
                currResponse: {},
            });
        }

        if (prevProps.currResponse !== this.props.currResponse) {
            this.setState({
                currResponse: this.props.currResponse,
            });
        }

        if (prevProps.preview.response.beingUsedForPreviewCalibration !== this.props.preview.response.beingUsedForPreviewCalibration){
            this.setState({
                getImageOnEveryClick: this.props.preview.response.beingUsedForPreviewCalibration,
            })
        }
    }

    getRackAndTray = () => {
        let key = this.props.casetteKey;
		let rack = parseInt(key.split("T")[0].split("R")[1]);
		let tray = parseInt(key.split("T")[1]);
		return [rack, tray];
	}

    componentWillUnmount = () => {
        document.removeEventListener("keypress", this.onKeyPress, false);
    }

    onKeyPress = (e) => {
        if (e.keyCode === 127 
            && this.state.pointSelectionMode === pointSelectionModeVals.FINE 
            && this.state.pointAlreadyPresent) {
            this.deleteFineFocusPoint();
        }
    }

    drawMarker = (x, y, vectorSource, type) => {
        let feature = new Feature({
            type: type,
            geometry: new Point([x, y]),
        });
        vectorSource.addFeature(feature);
    }

    onloadRunner = () => {
        let extent = [0, 0, this.image.width, this.image.height];
        let projection = new Projection({
            code: 'preview-image',
            units: 'pixels',
            extent: extent,
        });

        let styles = {
            'coarseFocusMarker': new Style({
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({color: 'red'}),
                    stroke: new Stroke({
                        color: 'white',
                        width: 2,
                    }),
                }),
            }),
            'fineFocusMarker': new Style({
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({color: 'blue'}),
                    stroke: new Stroke({
                        color: 'white',
                        width: 2,
                    }),
                }),
            }),
            'provisionalPointMarker': new Style({
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({color: '#7CFC00'}),
                    stroke: new Stroke({
                        color: 'white',
                        width: 2,
                    }),
                }),
            }),
            'selectedFineFocusMarker': new Style({
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({color: 'yellow'}),
                    stroke: new Stroke({
                        color: 'white',
                        width: 2,
                    }),
                }),
            }),
        };

        let coarseFocusVectorSource = new VectorSource({});
        let coarseFocusVectorLayer = new VectorLayer({
            source: coarseFocusVectorSource,
            visible: true,
            zIndex: 10,
            style: function (feature) {
                return styles[feature.get('type')];
            },
        });

        this.drawMarker(this.props.previewSlotsOnly.dropDistancePoint[0].x, this.image.height - this.props.previewSlotsOnly.dropDistancePoint[0].y,
            coarseFocusVectorSource, 'coarseFocusMarker');

        let fineFocusVectorSource = new VectorSource({});
        let fineFocusVectorLayer = new VectorLayer({
            source: fineFocusVectorSource,
            visible: false,
            zIndex: 5,
            style: function (feature) {
                return styles[feature.get('type')];
            },
        });

        for (let island in this.props.previewSlotsOnly.focusPoints) {
            for (let i = 0; i < this.props.previewSlotsOnly.focusPoints[island].length; i++) {
                let focusUnit = this.props.previewSlotsOnly.focusPoints[island][i];
                if (focusUnit.length > 0) {
                    this.drawMarker(focusUnit[0].x, this.image.height - focusUnit[0].y, 
                        fineFocusVectorSource, 'fineFocusMarker');
                }
            }
        }

        let provisionalPointVectorSource = new VectorSource({});
        let provisionalPointVectorLayer = new VectorLayer({
            source: provisionalPointVectorSource,
            visible: true,
            zIndex: 20,
            style: function (feature) {
                return styles[feature.get('type')];
            },
        });

        let previewUrl = '/dev-ssd/' + this.props.preview.response.uploadLocation + '?time=' + Date.now();
        let thresholdUrl = '/dev-ssd/' + this.props.preview.response.maskLocation + '?time=' + Date.now();

        if (this.state.map instanceof Map) {
            const layers = [...this.state.map.getLayers().getArray()];
            layers.forEach((layer) => this.state.map.removeLayer(layer));
            this.state.map.setLayerGroup(new LayerGroup({
                layers: [
                    new ImageLayer({
                        source: new Static({
                            url: getStateAwareUrl(previewUrl),
                            projection: projection,
                            imageExtent: extent,
                        }),
                        zIndex: 1,
                    }), 
                    new ImageLayer({
                        source: new Static({
                            url: getStateAwareUrl(thresholdUrl),
                            projection: projection,
                            imageExtent: extent,
                        }),
                        zIndex: 2,
                        opacity: 0.1,
                    }),
                    coarseFocusVectorLayer,
                    fineFocusVectorLayer,
                    provisionalPointVectorLayer
                ],
            }));
            this.state.map.setView(new View({
                projection: projection,
                center: getCenter(extent),
                zoom: 1,
                maxZoom: 8,
                rotation: ((90 * Math.PI) / 180)
            }));

            this.setState({
                coarseFocusVectorSource,
                coarseFocusVectorLayer,
                fineFocusVectorSource,
                fineFocusVectorLayer,
                provisionalPointVectorSource,
                provisionalPointVectorLayer
            });
        } else {
            let map = new Map({
                controls: [],
                layers: [
                    new ImageLayer({
                        source: new Static({
                            url: getStateAwareUrl(previewUrl),
                            projection: projection,
                            imageExtent: extent,
                        }),
                        zIndex: 1,
                    }), 
                    new ImageLayer({
                        source: new Static({
                            url: getStateAwareUrl(thresholdUrl),
                            projection: projection,
                            imageExtent: extent,
                        }),
                        zIndex: 2,
                        opacity: 0.2,
                    }),
                    coarseFocusVectorLayer,
                    fineFocusVectorLayer,
                    provisionalPointVectorLayer
                ],
                target: 'map-advanced-scan-settings',
                view: new View({
                    projection: projection,
                    center: getCenter(extent),
                    zoom: 1,
                    maxZoom: 8,
                    rotation: ((90 * Math.PI) / 180)
                }),
            });

            let dblClickInteraction;
            map.getInteractions().getArray().forEach(function (interaction) {
                if (interaction instanceof DoubleClickZoom) {
                    dblClickInteraction = interaction;
                }
            });

            map.removeInteraction(dblClickInteraction);

            map.on('click', this.getFortyXImage);

            this.setState({
                map,
                coarseFocusVectorSource,
                coarseFocusVectorLayer,
                fineFocusVectorSource,
                fineFocusVectorLayer,
                provisionalPointVectorSource,
                provisionalPointVectorLayer
            });
        }
    }

    getFortyXImage = (e) => {
        let x = Math.trunc(e.coordinate[0]);
        let y = Math.trunc(e.coordinate[1]);

        // @Spandan check for coordinate inside selected region removed for demo purpose

        let isInsideRegion = (x >= this.props.previewSlotsOnly.actualRegion[0] &&
            x <= this.props.previewSlotsOnly.actualRegion[2] &&
            (this.image.height - y) >= this.props.previewSlotsOnly.actualRegion[1] &&
            (this.image.height - y) <= this.props.previewSlotsOnly.actualRegion[3])

        if (isInsideRegion) {
            if (this.state.getImageOnEveryClick) {
                this.getImage(x, y, false, true);
                this.addCoarseFocusPoint(x, this.image.height - y)
            } else {
                if (this.state.pointSelectionMode === pointSelectionModeVals.COARSE) {
                    this.addCoarseFocusPoint(x, this.image.height - y);
                } else if (this.state.pointSelectionMode === pointSelectionModeVals.FINE) {
                    this.checkIfFineFocusPointAlreadyExists(x, y);
                }
            }
        } else {
            message.error("Point not inside the selected region.", 2.5);
        }
    }

    getFortyXImageDDPoint = (requiredDD, requiredFF) => {
        let coarseFocusPointCoordinate = this.state.coarseFocusVectorSource.getFeatures()[0].getGeometry().getCoordinates();
        this.getImage(coarseFocusPointCoordinate[0], coarseFocusPointCoordinate[1], requiredDD, requiredFF);
    }

    getImage = (x, y, requiredDD, doFF) => {
        this.props.dispatch(setDeviceBusy(this.props.deviceId));
        this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.GETTING_IMAGE));

        let doDD = this.state.isFirstTime || requiredDD;
        let rack_and_tray = this.getRackAndTray();
        const rack = rack_and_tray[0];
        const tray = rack_and_tray[1];

        let url = `/delayed_server/devices/` + this.props.deviceId + '/get_forty_x_image_from_scan_preview' + "/?slot_id=" + this.props.id + "&rack=" + rack + "&tray=" + tray + "&x=" + x + "&y=" + (this.image.height - y) + "&exp=" + (this.state.sliderValues[ExposureKey.name.toLowerCase()]) + "&gamma=" + (this.state.sliderValues[GammaKey.name.toLowerCase()]) + "&dd=" + (doDD) + "&amount=" + (this.state.sliderValues[EnhanceKey.name.toLowerCase()]) + "&ff=" + (doFF);
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    // Enable image showing
                    let currImagePos = [x, this.image.height - y];
                    let pointAlreadyPresent = false;
                    if (this.state.pointSelectionMode === pointSelectionModeVals.COARSE) {
                        let coarseFocusPointCoordinate = this.state.coarseFocusVectorSource.getFeatures()[0].getGeometry().getCoordinates();
                        for (let xVal = x - 15; xVal <= x + 15; xVal++) {
                            for (let yVal = y - 15; yVal <= y + 15; yVal++) {
                                if (xVal === coarseFocusPointCoordinate[0] && yVal === coarseFocusPointCoordinate[1]) {
                                    pointAlreadyPresent = true;
                                    break;
                                }
                            }
                            if (pointAlreadyPresent) {
                                break;
                            }
                        }
                    } else if (this.state.pointSelectionMode === pointSelectionModeVals.FINE) {
                        let fineFocusPointCoordinate = this.state.fineFocusVectorSource.getFeatures().map((feature) => {
                            return [feature.getGeometry().getCoordinates()[0], feature.getGeometry().getCoordinates()[1]];
                        });
                        for (let xVal = x - 15; xVal <= x + 15; xVal++) {
                            for (let yVal = y - 15; yVal <= y + 15; yVal++) {
                                if (this.checkValuesInCoordinateArray(xVal, yVal, fineFocusPointCoordinate)) {
                                    pointAlreadyPresent = true;
                                    currImagePos = [xVal, this.image.height - yVal];
                                    break;
                                }
                            }
                            if (pointAlreadyPresent) {
                                break;
                            }
                        }
                    }
                    this.state.provisionalPointVectorSource.clear();
                    if (!pointAlreadyPresent) {
                        this.drawMarker(x, y, this.state.provisionalPointVectorSource, 'provisionalPointMarker');
                    } else {
                        this.plotFinePoints(this.state.currResponse, true, currImagePos);
                    }
                    this.setState({
                        showLatestImage: true,
                        currImagePos,
                        pointAlreadyPresent,
                        isFirstTime:false,
                    });
                } else {
                    this.setState({
                        showLatestImage: false,
                        currImagePos: [],
                        pointAlreadyPresent: false,
                    });
                    message.error("Not able to get image. Please try some different point.", 2.5);
                }
                this.props.dispatch(setDeviceIdle(this.props.deviceId));
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
            .catch(_ => {
                this.setState({
                    showLatestImage: false,
                    currImagePos: [],
                    pointAlreadyPresent: false,
                });
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                message.error("Not able to get image. Please try some different point.", 2.5);
            })
    }

    // TODO : this logic should be handled in backend scano
    addCoarseFocusPoint = (xPixel, yPixel) => {
        this.props.dispatch(setDeviceBusy(this.props.deviceId));
        console.log("new dd point ", xPixel, yPixel);
        console.log("old list: ", this.props.previewSlotsOnly.dropDistancePoint)
        console.log("DD points count: ", this.props.previewSlotsOnly.dropDistancePointLength);

        let dropDistancePoints = [...this.props.previewSlotsOnly.dropDistancePoint];
        if (dropDistancePoints.length === this.props.previewSlotsOnly.dropDistancePointLength) {
            dropDistancePoints.unshift({x: xPixel, y: yPixel});
            console.log('added point for first time');
        } else {
            dropDistancePoints[0] = {x: xPixel, y: yPixel};
            console.log("just updating dd  point");
        } 

        let rack_and_tray = this.getRackAndTray();

        const url = '/server/devices/' + this.props.deviceId + "/set_drop_distance_point/?slot_id=" + this.props.id;
        const data = {
            points: dropDistancePoints,
            rack: rack_and_tray[0],
            tray: rack_and_tray[1]
        }
        post_response(url, data)
        .then(response => {
            if (response.status === 200) {
                this.state.coarseFocusVectorSource.clear();
                this.state.provisionalPointVectorSource.clear();
                this.drawMarker(xPixel, this.image.height - yPixel, 
                    this.state.coarseFocusVectorSource, 'coarseFocusMarker');
                this.props.dispatch(setDropDistancePointOnly(this.props.id, dropDistancePoints));
                this.setState({
                    pointAlreadyPresent: true,
                    currResponse: response,
                });
            }
            else {
                message.error("Not able to add coarse focus point. Please contact admin.", 2.5);
            }
            this.props.dispatch(setDeviceIdle(this.props.deviceId));
        })
        .catch(err => {
            this.props.dispatch(setDeviceIdle(this.props.deviceId));
            message.error("Not able to add coarse focus point. Please contact admin.", 2.5);
        })
    }

    ignoreFocusPoint = () => {
        this.state.provisionalPointVectorSource.clear();
        this.setState({
            showLatestImage: false,
            currImagePos: [],
            pointAlreadyPresent: false,
        });
    }

    deleteFineFocusPoint = () => {

        let islandID = -1, index = -1;

        for (let island in this.props.previewSlotsOnly.focusPoints) {
            for (let i = 0; i < this.props.previewSlotsOnly.focusPoints[island].length; i++) {
                let focusUnit = this.props.previewSlotsOnly.focusPoints[island][i];
                if (focusUnit.length > 0 
                        && focusUnit[0].x === this.state.currImagePos[0] 
                        && focusUnit[0].y === this.state.currImagePos[1]) {
                    islandID = island;
                    index = i;
                    break;
                }
            }
        }

        if (islandID === -1 || index === -1) {
            message.error("Not able to delete point. Please contact admin.", 2.5);
        } else {

            this.props.dispatch(setDeviceBusy(this.props.deviceId));

            let partsOfUrl = "api~scan~delete_focus_point";
            let url = `/scano/` + this.props.deviceId + `/` + partsOfUrl + "/?slot_id=" + this.props.id + "&island_id=" + islandID + "&index=" + index;
            get_response(url)
                .then(response => {
                    if (response.status === 200) {
                        this.plotFinePoints(response, false, []);
                        this.setState({
                            currResponse: response,
                        });
                    }
                    else {
                        message.error("Not able to delete point. Please contact admin.", 2.5);
                    }
                    this.props.dispatch(setDeviceIdle(this.props.deviceId));
                })
                .catch(err => {
                    this.props.dispatch(setDeviceIdle(this.props.deviceId));
                    message.error("Not able to delete point. Please contact admin.", 2.5);
                })
        }
    }

    checkIfFineFocusPointAlreadyExists = (xPixel, yPixel) => {
        let currImagePos = [xPixel, this.image.height - yPixel];
        let pointAlreadyPresent = false;
        let fineFocusPointCoordinate = this.state.fineFocusVectorSource.getFeatures().map((feature, index) => {
            return [feature.getGeometry().getCoordinates()[0], feature.getGeometry().getCoordinates()[1]];
        });
        for (let xVal = xPixel - 15; xVal <= xPixel + 15; xVal++) {
            for (let yVal = yPixel - 15; yVal <= yPixel + 15; yVal++) {
                if (this.checkValuesInCoordinateArray(xVal, yVal, fineFocusPointCoordinate)) {
                    pointAlreadyPresent = true;
                    currImagePos = [xVal, this.image.height - yVal];
                    break;
                }
            }
            if (pointAlreadyPresent) {
                break;
            }
        }
        if (pointAlreadyPresent) {
            this.plotFinePoints(this.state.currResponse, true, currImagePos);
        }
        this.setState({
            currImagePos,
            pointAlreadyPresent,
        });
        if(!pointAlreadyPresent) {
            this.addFineFocusPoint(xPixel, this.image.height - yPixel);
        }
    }

    addFineFocusPoint = (xPixel, yPixel) => {

        this.props.dispatch(setDeviceBusy(this.props.deviceId));

        let partsOfUrl = "api~scan~add_focus_point";
        let url = `/scano/` + this.props.deviceId + `/` + partsOfUrl + "/?slot_id=" + this.props.id + "&x=" + xPixel +
            "&y=" + yPixel;
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    this.plotFinePoints(response, false, []);
                    this.setState({
                        currResponse: response,
                    });
                }
                else {
                    message.error("Not able to add fine focus point. Please contact admin.", 2.5);
                }
                this.props.dispatch(setDeviceIdle(this.props.deviceId));
            })
            .catch(err => {
                this.props.dispatch(setDeviceIdle(this.props.deviceId));
                message.error("Not able to add fine focus point. Please contact admin.", 2.5);
            })
    }

    plotFinePoints = (response, markCurrPoint, currPoint) => {
        this.state.fineFocusVectorSource.clear();
        this.state.provisionalPointVectorSource.clear();

        for (let island in response.data.focusPoints) {
            for (let i = 0; i < response.data.focusPoints[island].length; i++) {
                let focusUnit = response.data.focusPoints[island][i];
                if (focusUnit.length > 0) {
                    if (markCurrPoint && currPoint[0] === focusUnit[0].x && currPoint[1] === focusUnit[0].y) {
                        this.drawMarker(focusUnit[0].x, this.image.height - focusUnit[0].y, 
                            this.state.fineFocusVectorSource, 'selectedFineFocusMarker');
                    } else {
                        this.drawMarker(focusUnit[0].x, this.image.height - focusUnit[0].y, 
                            this.state.fineFocusVectorSource, 'fineFocusMarker');
                    }
                }
            }
        }
        this.props.dispatch(setFocusPoints(this.props.id, response.data.focusPoints));
        this.setState({
            showLatestImage: false,
            currImagePos: [],
            pointAlreadyPresent: false,
        });
    }

    changePointSelectionMode = (key) => {
        if (key === pointSelectionModeVals.COARSE) {
            this.state.fineFocusVectorLayer.setVisible(false);
            this.state.coarseFocusVectorLayer.setVisible(true);
        } else if (key === pointSelectionModeVals.FINE) {
            this.state.coarseFocusVectorLayer.setVisible(false);
            this.state.fineFocusVectorLayer.setVisible(true);
        } else if (key === pointSelectionModeVals.CAMERA_SETTINGS) {
            this.state.coarseFocusVectorLayer.setVisible(false);
            this.state.fineFocusVectorLayer.setVisible(false);
        }
        this.state.provisionalPointVectorSource.clear();
        this.setState({
            pointSelectionMode: key,
            showLatestImage: false,
            currImagePos: [],
            pointAlreadyPresent: false,
        });
    }

    checkValuesInCoordinateArray = (x, y, coordinateArray) => {
        for (let i = 0; i < coordinateArray.length; i++) {
            if (coordinateArray[i][0] === x && coordinateArray[i][1] === y) {
                return true;
            }
        }
        return false;
    }

    onGetImageToggle = (checked) => {
        if (this.state.pointSelectionMode === pointSelectionModeVals.FINE) {
            this.plotFinePoints(this.state.currResponse, false, []);
        }
        this.setState({
            getImageOnEveryClick: checked,
            showLatestImage: false,
            currImagePos: [],
            pointAlreadyPresent: false,
        });
    }

    changeDefaultForStain = (id) => {
        if ((((this.props.deviceStatus[this.props.deviceId] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold !== true){
            let default_setting = {
                "default_setting": id
            }
            patch(`/api/stain/settings/${this.props.preview?.specimenType}/`, default_setting)
                .then((setting) => {
                    let stainSetting = this.props.defaultStainSettings;
                    stainSetting[setting.stain_name].default_setting = setting.default_setting
                    this.props.dispatch(updateDefaultStainSettings(stainSetting));
                })
                .catch(error => error_manager(`Failed To Update`, error))
        }
    }

    addAllDisplaySettings = (new_name) =>
        fetchAllDisplaySettings()
            .then((settings) => {
                let dispSetting =
                    settings.reduce((settings, setting) => Object.assign(settings, {
                        [setting.id]: setting,
                    }), {})
                this.props.dispatch(updateDisplaySettingsList(dispSetting))
                this.props.dispatch(updateSettings(new_name))
                let id = getIdFromName(this.props.displaySettingsList, new_name)
                this.props.dispatch(setScanProfile(this.props.id, id))
                this.changeDefaultForStain(id)
                this.setState({
                    isFetching: false
                })
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
            .catch((error) => {error_manager("Failed to fetch display settings", error)
                console.log(error)})

    createSetting = (name) => {
        this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
        let old_setting = this.props.displaySettingsList[getIdFromName(this.props.displaySettingsList, this.props.displaySettings)]
        let oldName = old_setting.name
        let token = 0;
        if (typeof (name) === 'object') {
            oldName = oldName.slice(0,7);
            if(!Number.isNaN(Number(oldName.charAt(6)))){
                token = Number(oldName.charAt(6))
            }
            oldName = oldName.slice(0,6);
            name = oldName+(token+1);
        }
        if (name === "") {
            this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            this.setState({
                isFetching: false
            })
            message.error("Display Setting name cannot be empty")
            return
        }
        if (name.length > 7) {
            message.error("Display settings name should not exceed 7 chars")
            return;
        }
        if (getIdFromName(this.props.displaySettingsList, name)) {
            this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            this.setState({
                isFetching: false
            })
            message.error("Display Setting with this name already exists")
            return
        }
        old_setting.name = name
        old_setting.id = undefined
        this.setState({
            isFetching: true
        })
        post(`/api/display/settings/`, old_setting)
            .then(setting => this.addAllDisplaySettings(setting.name))
            .catch(error => error_manager(`Failed to create display setting`, error))
    }

    editSetting = (name) => {
        this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
        let old_setting = this.props.displaySettingsList[getIdFromName(this.props.displaySettingsList, this.props.displaySettings)]
        if (name===""){
            this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            this.setState({
                isFetching: false
            })
            message.error("Display Setting name cannot be empty")
            return
        }
        if (name.length > 7) {
            this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            message.error("Display settings name should not exceed 7 chars")
            return;
        }
        if (getIdFromName(this.props.displaySettingsList, name)) {
            this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            this.setState({
                isFetching: false
            })
            message.error("Display Setting with this name already exists")
            return
        }
        old_setting.name = name
        this.setState({
            isFetching: true
        })
        patch(`/api/display/settings/${old_setting.id}/`, old_setting)
            .then(
                (_) => {
                    this.addAllDisplaySettings(name)
                })
            .catch(error => error_manager(`Failed to edit name`, error))
    }

    getIndividualSliders = (is_superuser) => {
        let retObj = [];
        let displaySettings = this.props.displaySettingsList[getIdFromName(this.props.displaySettingsList, this.props.displaySettings)];
        advancedModeSettingKeys.forEach(setting => {
            retObj.push(getSettingComponent(setting, this.state.sliderValues[setting.name.toLowerCase()],
                value => this.updateSettingValue(setting, value), !isOwner(displaySettings), "black",
                "secondary"))
        })
        advancedModeSlideSettingKeys.forEach(setting => {
            if(setting.name === 'Exposure') {
                setting.min = this.state.livemodeConfig.minExposure ? this.state.livemodeConfig.minExposure : 5;
                setting.max = this.state.livemodeConfig.maxExposure ? this.state.livemodeConfig.maxExposure : 25;
            }
            if(setting.name === 'Gamma') {
                setting.min = this.state.livemodeConfig.minGamma ? this.state.livemodeConfig.minGamma : 0.1;
                setting.max = this.state.livemodeConfig.maxGamma ? this.state.livemodeConfig.maxGamma : 1;
            }
            retObj.push(getSettingComponent(setting, this.state.sliderValues[setting.name.toLowerCase()],
                value => this.updateSettingValue(setting, value), !isOwner(displaySettings), "black",
                "secondary"))
        })
        if(is_superuser){
            advancedModeAdminKeys.forEach(setting => {
                retObj.push(getSettingComponent(setting, this.state.sliderValues[setting.name.toLowerCase()],
                    value => this.updateSettingValue(setting, value), !isOwner(displaySettings), "black",
                    "secondary"))
            })
        }
        return retObj;
    }

    handleCheck = () => {
        // Clears running timer and starts a new one each time the user types
        clearTimeout(this.Timer);
        this.Timer = setTimeout(() => {
            this.getFortyXImageDDPoint(false, false)
        }, 500);
    }

    updateSettingValue = (setting, value) => {
        let currentlyUsedDisplaySettingsList = this.props.displaySettingsList
        let id = getIdFromName(currentlyUsedDisplaySettingsList, this.props.displaySettings)
        if(value===""){
            currentlyUsedDisplaySettingsList[id][setting.name.toLowerCase()] = value
            this.props.dispatch(updateDisplaySettingsList(currentlyUsedDisplaySettingsList))
            return;
        }
        let previousSliderValues = this.state.sliderValues
        previousSliderValues[setting.name.toLowerCase()] = value
        this.setState({
            sliderValues: previousSliderValues
        })
        let changedSettingParameter = {
            [setting.name.toLowerCase()]: value,
        };
        if (id) {
            patch(`/api/display/settings/${id}/`, changedSettingParameter)
                .then((setting) => {
                    let updatedDisplaySettings = this.props.displaySettingsList
                    updatedDisplaySettings[id] = setting
                    this.props.dispatch(updateDisplaySettingsList(updatedDisplaySettings))
                })
                .catch(error => error_manager(`Failed to update ${setting.name}`, error))
        }
        if(!(advancedModeSettingKeysNames.includes(setting.name)) && this.state.getImageOnEveryClick){
            this.handleCheck();
        }
    }

    modifySettings = (newDisplaySettings) => {
        let sliderValue = this.state.sliderValues
        advancedModeKeyNames.forEach((key) => {
            sliderValue[key] = newDisplaySettings[key]
        })
        this.setState({
            sliderValues: sliderValue
        })
        if(this.state.getImageOnEveryClick){
            this.getFortyXImageDDPoint(false, false)
        }
    }

    changeScanningProfile = (value) => {
        let scanningProfile = this.props.displaySettingsList[value];
        this.modifySettings(scanningProfile)
        this.props.dispatch(updateSettings(scanningProfile.name))
        this.props.dispatch(setScanProfile(this.props.id, scanningProfile.id));
        this.changeDefaultForStain(scanningProfile.id);
    }


    render() {
        let displaySettings = this.props.displaySettingsList[getIdFromName(this.props.displaySettingsList, this.props.displaySettings)];
        const autoPreviewThreshold = (((this.props.deviceStatus[this.props.deviceId] || {}).scanner_health || {}).scanner_response|| {}).autoPreviewThreshold;
        let busy = (((this.props.deviceStatus[this.props.deviceId] || {}).scanner_health || {}).scanner_response|| {})['busy'] || this.state.isFetching;
        let is_superuser = isTrue(cookie.load("superuser"));
        const antIcon = <LoadingOutlined spin/>;
        return(
            <div>
                <Spin indicator={antIcon} spinning={this.state.isFetching} tip={"loading..."} wrapperClassName={'full-parent'}>
                    <Row>
                        <Col span={this.state.getImageOnEveryClick ? 5 : 9} offset={1}>
                            <div tabIndex="0" id={"map-advanced-scan-settings"} className="advanced-settings-preview-map-container"></div>
                        </Col>
                        <Col span={this.state.getImageOnEveryClick ? 16 : 12} offset={1} style={{paddingTop: "20px"}}>
                            { this.state.getImageOnEveryClick ?
                                <>
                            <Row>
                                <Col span={4} style={{marginLeft:'20px'}}>
                                    <Button className="black-scan-btn" onClick={() => {this.getFortyXImageDDPoint(true, false)}}>Coarse Focus</Button>
                                </Col>
                            </Row>
                            <Row style={{height: "500px", paddingTop: "20px"}}>
                                <Col span={16}>
                                    {!busy ?
                                        this.state.showLatestImage ?
                                            this.getRenderedImageComponent()
                                            :
                                            this.getBlankComponentWithText("Click on the preview image to get Live image of that location.")
                                        :
                                        this.getBlankComponentWithText("Getting Image...")
                                    }
                                </Col>
                                <Col span={8}>
                                    {!busy ? getViewerSettingDropdown(this.props.preview?.specimenType, this.props.displaySettings, this.props.displaySettingsList, this.changeScanningProfile, true, true, this.createSetting, (!isOwner(displaySettings) && !hasEditSlideSettingPermission()) ? null : this.editSetting, autoPreviewThreshold) : null}
                                    {!busy ? getSliderRows(is_superuser, this.props.displaySettingsList, this.props.displaySettings, this.createSetting, this.getIndividualSliders) : null}
                                </Col>
                            </Row>
                                </>
                    :
                                <div style={{height: "500px", paddingTop: "80px"}}>
                            {!busy ? getViewerSettingDropdown(this.props.previewSlotsOnly?.specimenType, this.props.displaySettings,
                                this.props.displaySettingsList, this.changeScanningProfile, true, true, this.createSetting,
                                !isOwner(displaySettings) ? null : this.editSetting, autoPreviewThreshold):null}
                            {!busy ? getSliderRows(is_superuser, this.props.displaySettingsList, this.props.displaySettings, this.createSetting, this.getIndividualSliders):null}
                                </div>
                    }
                        </Col>
                    </Row>
                </Spin>
            </div>
        )
    }

    getBlankComponentWithText(text) {
        return <div className="blank-forty-x-image">
            {text}
        </div>;
    }

    updateImageCoordinates = (move) => {
        this.setState({
            move: move
        })
    }

    getRenderedImageComponent() {
        return <FortyXImage position={this.state.move}
                            brightness={this.state.sliderValues[BrightnessKey.name.toLowerCase()]}
                            contrast={this.state.sliderValues[ContrastKey.name.toLowerCase()]}
                            updateImageCoordinates={this.updateImageCoordinates}/>;
    }
}


const mapStateToProps = (state, ownProps) => {
    let {displaySettings, displaySettingsList, defaultStainSettings} = state.gammaStateReducer
    return {
        deviceStatus: state.deviceStatusReducer[ownProps.deviceId],
        previewSlotsOnly: state.previewStatusReducer[ownProps.id],
        displaySettings,
        displaySettingsList,
        defaultStainSettings
    }
}

export default connect(mapStateToProps)(AdvancedPreviewSettingsComp);